// @ts-nocheck TODO: fix types for the entire file

import styled from '@emotion/styled';
import { IconButton } from 'components/Buttons/IconButton';
import pxToEm from 'theme/pxToEm';

export const BackToTopButton = styled(IconButton)`
  position: fixed;
  right: ${pxToEm(20)};
  bottom: ${pxToEm(85)};
  cursor: pointer;
  z-index: 10;
  width: ${pxToEm(56)};
  height: ${pxToEm(56)};
  &:hover,
  &:focus {
    background-color: ${({ theme }) => theme.palette.primary.main};
  }
  svg {
    transform: rotate(180deg);
    width: ${pxToEm(39)}!important;
  }
  @media (max-width: ${pxToEm(767)}) {
    bottom: ${pxToEm(80)};
  }
`;

export const SpaceHolder = styled.div`
  min-height: 300px;
  padding-top: 8px;
`;
